'use strict';
// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('UnidadesService', function($http, $rootScope) {
  return {
    all: function() {
      return $http.get(`${SERVER + API_VERSION }unidades`);
    },

    all_with_conversions: function() {
      return $http.get(`${SERVER + API_VERSION }unidades/unidades_com_conversoes`);
    },

    // eslint-disable-next-line max-lines-per-function, max-params
    getMeasureUnitys: function() {
      const unidades = $rootScope.unidadesWithConversions;
      const unidadesParsed = unidades.map((unidade) => {
        // eslint-disable-next-line max-len
        const compativeis = unidades.filter((uc) => (uc.origem === unidade.origem || uc.destino === unidade.destino)).map((u) => u.origem);
        const nomeLowcase = unidade.origem.toLowerCase();
        const abbrLowcase = unidade.abreviatura.toLowerCase();

        return {
          id: unidade.codigo,
          nome: `${nomeLowcase }/ha`,
          nomeAbreviado: `${abbrLowcase }/ha`,
          abreviatura: abbrLowcase,
          conversao: 1/unidade.taxa,
          reverseConversao: unidade.taxa,
          nomeSistema: unidade.origem,
          compativeis: compativeis
        };
      });

      return unidadesParsed;
    },

    getUnidadesCompativeis: function(unidade) {
      if (unidade.compativeis) {
        const unidades = this.getMeasureUnitys();

        if (unidade && Object.keys(unidade).length) {
          const index = unidades.reduce(function(result, unity) {
            result[unity.nomeSistema] = unity;
            return result;
          }, {});

          return _.uniqBy([unidade].concat(unidade.compativeis.map(function(unidadeCompativel) {
            return index[unidadeCompativel];
          })), 'id');
        }
        return _.uniqBy(unidades, 'id');
      }
      return [unidade];
    },

    getMeasureUnitysFromDescription: function(descricao) {
      const unitys = this.getMeasureUnitys();

      if (!descricao) {
        return {};
      }

      return unitys.find(({ nomeSistema }) => descricao.toUpperCase() === nomeSistema) || {};
    },

    getPressureUnitys: function() {
      return ['psi', 'bar', 'kPa'];
    }
  };
});
